/**  Состояния карт. */
export enum CardsStates {
  /** Выпускается. */
  Issued = 0,

  /**  Активна. */
  Active = 1,

  /** Заблокирована. */
  Blocked = 2,

  /** Разблокируется. */
  Unblocking = 3,

  /** Перевыпускается. */
  ReIssued = 4,

  /** Удаляется. */
  Deleting = 5,

  /** Удалена. */
  Deleted = 6,

  /** Блокируется. */
  Blocking = 7,

  /** Заблокирована на пересылку из ПЦ. */
  SendingFromPC = 8,

  /** Аннулируется. */
  Closing = 9,

  /** Аннулирована. */
  Closed = 10,

  /** Просрочена. */
  Expired = 11,

  /** Аннулируется. */
  ManualClosed = 12,

  /** Заблокирована после получения из ПЦ. */
  RECEIVEDFROMPC = 13,

  /** Передана агенту. */
  SendedToAgent = 14,

  /** Передана агенту почтой. */
  SendedToAgentByPost = 15,

  /** Получена агентом. */
  ReceivedByAgent = 16,

  /** Передана клиенту. */
  SendedToClient = 17,

  /** Передана клиенту почтой. */
  SendedToClientByPost = 18,

  /** Конверт бракован. */
  CoverDefective = 19,

  /** Конверт потерян при пересылке. */
  CoverMissed = 20
}
